import { useState } from 'react';
import PropTypes from 'prop-types';
import { useNavigate } from 'react-router-dom';

import TextInput from '../../../common/inputs/text-input/TextInput';
import Checkbox from '../../../common/inputs/checkbox/Checkbox';
import Button from '../../../common/button/Button';

import { ReactComponent as LogoLight } from '../../../../resources/logos/atp-logo-light.svg';

import { ReactComponent as SignInGoogle } from '../../../../resources/buttons/sign-in-google.svg';
import { ReactComponent as SignInApple } from '../../../../resources/buttons/sign-in-apple.svg';
import { ReactComponent as GooglePlay } from '../../../../resources/icons/google_play_greyed_out.svg';
import { ReactComponent as AppStore } from '../../../../resources/icons/app_store_greyed_out.svg';
import { ReactComponent as AppGallery } from '../../../../resources/icons/appgallery_greyed_out.svg';
import { ReactComponent as EyeOpen } from '../../../../resources/icons/eye-open.svg';
import { ReactComponent as EyeClosed } from '../../../../resources/icons/eye-closed.svg';

import './login.scss';

const Login = ({ logIn, rememberUser, mobile }) => {
  const [email, setEmail] = useState('');
  const [password, setPassword] = useState('');
  const [rememberMe, setRememberMe] = useState(rememberUser ? rememberUser : false);
  const [passwordType, setPasswordType] = useState('password');

  const navigate = useNavigate();
  const APPLE_LOGIN_LINK = process.env.REACT_APP_APPLE_LOGIN_LINK;
  const GOOGLE_LOGIN_LINK = process.env.REACT_APP_GOOGLE_LOGIN_LINK;

  const handleSubmit = (event) => {
    event.preventDefault();
    logIn(email, password, rememberMe);
  };

  const changeViewPassword = () => {
    if (passwordType === 'password') {
      setPasswordType('input');
    } else {
      setPasswordType('password');
    }
  };

  if (mobile) {
    return (
      <div className="login__not-supported">
        <LogoLight className="login__logo-light" />
        <p>Thank you for visiting</p>
        <p>the African Trade Platform.</p>
        <p>Please visit atp-app.com in your browser on a computer or laptop.</p>
        <p>The mobile app is currently under development and will be coming soon!</p>
      </div>
    );
  }

  return (
    <section className="login">
      <div className="login__sign-up-link">
        <p>
          Not a member yet? <b onClick={() => navigate('/sign-up')}>Sign Up Now</b>
        </p>
      </div>
      <button className="login__provider-button" onClick={() => window.open(GOOGLE_LOGIN_LINK)}>
        <SignInGoogle data-testid="sign-in-with-google" />
      </button>
      <button className="login__provider-button" onClick={() => window.open(APPLE_LOGIN_LINK)}>
        <SignInApple data-testid="sign-in-with-apple" />
      </button>

      <p>or use your email account</p>

      <form className="login__form" onSubmit={handleSubmit} data-testid="login-form">
        <TextInput
          name="email"
          placeholder="Email"
          value={email}
          onChange={({ target }) => setEmail(target.value)}
          type="email"
          auth
        />
        <TextInput
          name="password"
          placeholder="Password"
          value={password}
          onChange={({ target }) => setPassword(target.value)}
          type={passwordType}
          auth
          icon={
            passwordType === 'password' ? (
              <div className="login__eye-open">
                <EyeOpen onClick={() => changeViewPassword()} />
              </div>
            ) : (
              <div className="login__eye-closed">
                <EyeClosed onClick={() => changeViewPassword()} />
              </div>
            )
          }
        />
        <section className="login__actions">
          <div className="login__remember-me">
            <Checkbox value={rememberMe} onChange={() => setRememberMe(!rememberMe)} />
            <p>Remember me</p>
          </div>
          <p onClick={() => navigate('/recover-password')} className="login__forgot-password">
            Forgot Password?
          </p>
        </section>

        <div className="login__button-container">
          <Button type="submit" onClick={handleSubmit} disabled={!email || !password}>
            Sign In
          </Button>
        </div>
      </form>
      <div className="login__coming-soon">
        <p>Mobile app coming soon</p>
        <div className="login__store-logos">
          <GooglePlay />
          <AppStore />
          <AppGallery />
        </div>
      </div>
    </section>
  );
};

Login.propTypes = {
  logIn: PropTypes.func.isRequired,
  rememberUser: PropTypes.bool,
};

Login.defaultProps = {
  rememberUser: false,
};

export default Login;
